import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useCopyModelMutation } from 'models/api'
import { Modal, TextAreaInput, TextInput } from 'src/components/ui'
import { FetchModel } from 'src/services'
import { getDefaultCopyModelName } from '../../model.utils'

type Props = {
  onClose: () => void
  model: FetchModel
  factoryId: string
  rootLink: string
}
export function CopyModelModal({
  rootLink,
  model,
  factoryId,
  onClose,
}: Props): JSX.Element {
  const [name, setName] = useState(getDefaultCopyModelName(model))
  const [description, setDescription] = useState(model.description || '')

  const copyMutation = useCopyModelMutation(factoryId, model)
  const navigate = useNavigate()

  function handleConfirm(): void {
    copyMutation.mutateAsync(
      { name, description, sourceId: model.id },
      {
        onSuccess: data => {
          if (data?.id) {
            navigate(`${rootLink}/models`)
          }
        },
        onError: () => {
          toast.error('Failed to copy the model.', { position: 'top-right' })
        },
      },
    )
  }

  return (
    <Modal
      title="Copy Model"
      isOpen
      close={onClose}
      footer={
        <Modal.Footer
          onCancel={onClose}
          onConfirm={handleConfirm}
          confirmLabel="Copy"
          type="success"
          buttonDisabled={!name || copyMutation.isLoading}
        />
      }
    >
      <div className="my-xs flex flex-col gap-s">
        <TextInput
          value={name}
          label="Model Name"
          onChange={e => setName(e.target.value)}
        />
        <TextAreaInput
          value={description}
          inputClassName="!w-[500px] max-h-[250px]"
          placeholder="Descriptive text"
          label="Description"
          labelSuffix="(Optional)"
          minRows={3}
          onChange={e => setDescription(e.target.value)}
        />
      </div>
    </Modal>
  )
}
